import { graphql } from 'react-apollo'
import getImageFromEntry, {
  MASTER,
  STANDARD,
} from '../../helpers/get-image-from-entry'
import getSponsoredTitle from '../../helpers/get-sponsored-topic'
import getDescriptiveLocation from '../../helpers/get-descriptive-location'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import { localISODate } from '../../helpers/date-helpers'
import query from './query.graphql'

const mapPropsToOptions = ({ centre, id }) => ({
  variables: {
    id,
    centreId: centre.sys.id,
    startsAt: localISODate(centre.timeZone),
  },
  errorPolicy: 'ignore',
})

const mapDataToProps = ({
  ownProps: { centre: ownCentre, id, slug },
  data: { centre: respCentre, loading, error },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!respCentre || !respCentre.news || !respCentre.news[0]) {
    return {
      error: new NotFoundError(),
    }
  } else if (slug !== respCentre.news[0].slug) {
    return {
      redirect: `/${ownCentre.slug}/news/${id}/${respCentre.news[0].slug}`,
    }
  }

  const news = respCentre.news[0]
  const allStores = (news.stores || []).filter(
    store => store.centre.sys.id === ownCentre.sys.id
  )
  const store = allStores.length === 1 ? allStores[0] : null

  const location = getDescriptiveLocation({
    ...(store &&
      store.physicalAddress && {
        physicalAddress: store.physicalAddress,
      }),
    ...(store && { storeTitle: store.storeTitle }),
  })
  return {
    entry: {
      body: news.bodyCopy,
      category: 'News',
      desktopImage: getImageFromEntry(news, MASTER),
      experiences: news.experiences,
      location,
      mobileImage: getImageFromEntry(news, STANDARD),
      retailCategories: news.retailCategories,
      shortDescription: news.shortDescription,
      slug: news.slug,
      store,
      stores: allStores.length ? allStores : null,
      title: news.title,
      topic: getSponsoredTitle(news),
      topics: news.topics,
      typename: news.__typename,
      analyticsMetadata: news.analyticsMetadata,
    },
  }
}

const withNewsDetail = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withNewsDetail
